var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChatsearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.33366 15.0001C9.81281 14.9998 11.2493 14.5046 12.4145 13.5934L16.0778 17.2567L17.2562 16.0784L13.5928 12.4151C14.5045 11.2498 15 9.81295 15.0003 8.33341C15.0003 4.65758 12.0095 1.66675 8.33366 1.66675C4.65783 1.66675 1.66699 4.65758 1.66699 8.33341C1.66699 12.0092 4.65783 15.0001 8.33366 15.0001ZM8.33366 3.33341C11.0912 3.33341 13.3337 5.57591 13.3337 8.33341C13.3337 11.0909 11.0912 13.3334 8.33366 13.3334C5.57616 13.3334 3.33366 11.0909 3.33366 8.33341C3.33366 5.57591 5.57616 3.33341 8.33366 3.33341Z",
    fill: "#374B5C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.51018 7.15507C9.82602 7.47174 10.0002 7.89007 10.0002 8.33341H11.6668C11.6676 7.89543 11.5815 7.46165 11.4136 7.05714C11.2457 6.65264 10.9992 6.28543 10.6885 5.97674C9.42685 4.71674 7.23935 4.71674 5.97852 5.97674L7.15518 7.15674C7.78852 6.52507 8.88018 6.52674 9.51018 7.15507Z",
    fill: "#374B5C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChatsearch);
export default __webpack_public_path__ + "static/media/chatsearch.08e8f1563ee2d0ce69d90d6b2b0b86bc.svg";
export { ForwardRef as ReactComponent };